// extracted by mini-css-extract-plugin
export default {"reviewCard":"ReviewCard_reviewCard__ln147","reviewCard__img":"ReviewCard_reviewCard__img__bewMq","reviewCard__content":"ReviewCard_reviewCard__content__RLD+N"};